<template>
  <UiManagementOrganizationMeta />
</template>

<script lang="ts" setup>
definePageMeta({
  fixed: true,
})

const { getPageAndCache } = usePage()
const { meta } = await getPageAndCache()
useHead(meta)
</script>

<style lang="scss" scoped>
</style>